/**
 * OperatorDashboard — post-setup Home screen.
 *
 * Renders when `checklist.isSetupComplete === true` (all 4 onboarding steps
 * are done). The screen is the operator's working surface:
 *   - Next Action banner (post-setup, e.g. republish after change)
 *   - Attention banners (gateway + plugin diagnostics)
 *   - Publish Status card (sub-cases A-D)
 *   - Setup progress while incomplete
 *   - Diagnostics entry, last when attention is needed
 *
 * Pre-setup merchants never see this surface — they get SetupWelcome instead.
 * The full card machinery is delegated to OperatorHome (the original home
 * component) to avoid duplicating the 1100+ lines of card / severity / publish
 * sub-case logic.
 */

import React from 'react';
import PropTypes from 'prop-types';
import OperatorHome from '../OperatorHome';

export default function OperatorDashboard(props) {
  return (
    <div
      data-testid="operator-dashboard"
      data-setup-complete="true"
    >
      <OperatorHome {...props} />
    </div>
  );
}

OperatorDashboard.propTypes = {
  operatorState: PropTypes.shape({}).isRequired,
  shopId: PropTypes.string,
  isLoading: PropTypes.bool,
  isServiceUpdating: PropTypes.bool,
  liveIndexing: PropTypes.shape({}),
  onStartIndexing: PropTypes.func,
  catalogSync: PropTypes.shape({}),
  pluginDiagnosticsSummary: PropTypes.shape({}),
  pluginCapabilities: PropTypes.shape({}),
  onPublish: PropTypes.func,
  trialChip: PropTypes.node,
};

OperatorDashboard.defaultProps = {
  shopId: null,
  isLoading: false,
  isServiceUpdating: false,
  liveIndexing: null,
  onStartIndexing: null,
  catalogSync: null,
  pluginDiagnosticsSummary: null,
  pluginCapabilities: null,
  onPublish: null,
  trialChip: null,
};
